import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { Box, Button, Heading } from "@miro-site/core";
import styled from "styled-components";
import EditableTemplatePreview from "./EditableTemplatePreview";
var MediaContainer = styled(Box).withConfig({
    componentId: "sc-9ff72b33-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.normalizeStyles({
        borderRadius: 8,
        overflow: "hidden",
        "& iframe": {
            position: "absolute",
            width: "100%",
            height: "100%",
            top: 0,
            left: 0,
            border: "none"
        }
    });
});
var EditableTemplateHeader = /*#__PURE__*/ React.forwardRef(function(_param, ref) {
    var metadataId = _param.metadataId, headline = _param.headline, onUseTemplateClick = _param.onUseTemplateClick, templateActions = _param.templateActions, props = _object_without_properties(_param, [
        "metadataId",
        "headline",
        "onUseTemplateClick",
        "templateActions"
    ]);
    var _$ref = useState(), wrapperStyles = _$ref[0], setWrapperStyles = _$ref[1];
    var _$ref1 = useState(), headerStyles = _$ref1[0], setHeaderStyles = _$ref1[1];
    var _$ref2 = useState(), previewStyles = _$ref2[0], setPreviewStyles = _$ref2[1];
    useEffect(function() {
        setWrapperStyles({
            display: [
                undefined,
                "flex",
                "flex",
                "flex"
            ],
            flexWrap: [
                undefined,
                "nowrap",
                "nowrap",
                "nowrap"
            ],
            flexDirection: [
                undefined,
                "column",
                "column",
                "column"
            ]
        });
        setHeaderStyles({
            display: [
                undefined,
                "flex",
                "flex",
                "flex"
            ],
            flexWrap: [
                undefined,
                "nowrap",
                "nowrap",
                "nowrap"
            ],
            flexDirection: [
                undefined,
                "row",
                "row",
                "row"
            ],
            alignItems: [
                undefined,
                "center",
                "center",
                "center"
            ],
            justifyContent: [
                undefined,
                "space-between",
                "space-between",
                "space-between"
            ]
        });
        setPreviewStyles({
            position: "relative",
            borderRadius: 8,
            width: [
                325,
                "100%",
                "100%",
                "100%"
            ],
            height: "100%"
        });
    }, []);
    return /*#__PURE__*/ _jsxs(Box, _object_spread_props(_object_spread({
        ref: ref,
        "data-test-id": true,
        "data-track-place": "template-page-header",
        $pb: 0,
        $styles: wrapperStyles
    }, props), {
        children: [
            /*#__PURE__*/ _jsxs(Box, _object_spread_props(_object_spread({
                $pb: [
                    20,
                    28,
                    28,
                    28
                ],
                $styles: headerStyles
            }, props), {
                children: [
                    /*#__PURE__*/ _jsx(Heading, {
                        as: "h1",
                        $variant: "h2",
                        $mb: [
                            20,
                            24,
                            24,
                            24
                        ],
                        children: headline
                    }),
                    /*#__PURE__*/ _jsx(Button, {
                        "data-track-id": "use-template",
                        "data-template-id": metadataId,
                        $buttonType: "primary",
                        $size: "medium",
                        $withArrow: true,
                        onClick: onUseTemplateClick,
                        $mb: [
                            12,
                            15
                        ],
                        children: templateActions.USE_TEMPLATE
                    })
                ]
            })),
            /*#__PURE__*/ _jsx(Box, {
                $mb: [
                    40,
                    null,
                    null,
                    null
                ],
                $styles: previewStyles,
                children: /*#__PURE__*/ _jsx(MediaContainer, {
                    children: /*#__PURE__*/ _jsx(EditableTemplatePreview, {})
                })
            })
        ]
    }));
});
export default EditableTemplateHeader;
